import { Component, Inject, Vue, Watch, Prop } from "vue-property-decorator";
import { UserService } from "../../services/UserService";
import {
  SNACKBAR_STYLE,
  STYLE_CLASSES
} from "../../../../shared/constants/StyleConstants";
import {
  COMPONENT_NAME_MODAL,
  FORM_VALIDATORS,
  LIST_DATA_EVENTS,
  TYPE_FIELDS
} from "../../../../shared/constants/FormConstants";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import {
  USER_CONSTANTS,
  USER_MESSAGES,
  USER_VALIDATORS,
  USER_PHOTO_FORMAT,
  USER_ACCESS,
  ERROR_CODES,
  NUMBER_PATTERN,
  BIRTHDAY_FIELD_MODEL,
  USER_STATES
} from "../../constants/UserConstants";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { GroupFullSchema } from "../../../InfoGroup/models/GroupFullSchema";
import {
  VJSF_OPTIONS,
  FORM_MESSAGES,
  FORM_CONSTANTS,
  PHONE_TRANSLATIONS
} from "../../../../shared/constants/FormConstants";
import { RolesService } from "../../../Roles/services/RolesService";
import { Http } from "@status/codes";
import { RoleInfo } from "../../../Roles/models/RoleInfo";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { HeaderUserTemplate } from "../../../UserTemplate/models/HeaderUserTemplate";
import { PhonePayload } from "../../../InfoGroup/models/PhonePayload";
import { HeaderInfoGroup } from "../../../InfoGroup/models/HeaderInfoGroup";
import { InfoGroupService } from "../../../InfoGroup/services/InfoGroupService";
import { InfoGroupDetail } from "../../../InfoGroup/models/InfoGroupDetail";
import { Response } from "../../../../shared/models/Response";
import { FieldUserKey } from "../../models/FieldUserKey";
import { FieldUserSchemaKey } from "../../models/FieldUserSchemaKey";
import { FORMS_CONSTANTS } from "../../../Forms/constants/FormsConstants";
import { FullSchema } from "../../../../shared/models/FullSchema";
import { PhoneModel } from "../../../../shared/models/PhoneModel";
import { LOCAL_STORAGE } from "../../../../shared/constants/FormConstants";
import FormModalViewer from "../../../../shared/components/FormModalViewer/FormModalViewer.vue";
import { FieldUser } from "../../models/FieldUser";
import { QUERY_STATE_ACTIVE } from "../../constants/UserConstants";
import { UserModel } from "../../models/UserModel";
import firebase from "firebase/app";
import "firebase/storage";
import { TitleList } from "@/shared/models/TitleList";
import { Utils } from "@/shared/utils/utils";
import { UserTempQuerySend } from "@/modules/UserTemplate/models/UserTempQuerySend";
import { QuerySearchRole } from "@/modules/Roles/models/QuerySearchRole";
import { NAME_KEY_CHART } from "@/shared/components/AddFieldGroup/constants/FieldGroupConstants";
import WarningDeleteMessage from "@/shared/components/WarningDeleteMessage/WarningDeleteMessage.vue";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE
} from "@/shared/constants/GeneralConstants";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import { DependenciesService } from "../../../Dependencies/services/DependenciesService";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { AxiosError } from "axios";
import {
  NAME_FIELD,
  USER_TEMPLATES_ACCESS
} from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { INFO_GROUPS_ACCESS } from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { DependencyQuery } from "../../models/DependencyQuery";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import lodash from "lodash";
import SaveUserTemplate from "../../../UserTemplate/components/SaveUserTemplate/SaveUserTemplate.vue";

import SaveRole from "../../../Roles/components/SaveRole/SaveRole.vue";
import SaveDependencies from "../../../Dependencies/components/SaveDependencies/SaveDependencies.vue";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import ImgAvatar from "./../../../../shared/components/ImgAvatar/ImgAvatar.vue";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import { PROFILE_CONSTANTS } from "@/modules/Profile/constants/ProfileConstants";
import { UserForm } from "@/modules/UserTemplate/models/UserForm.model";
import { FIELDS_MAPED_FROM_USER } from "@/modules/MedicalOrder/constants/MedicalOrderConstants";
import { ListService } from "@/modules/List/services/ListService";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";

@Component({
  name: "SaveUser",
  components: {
    ModalTemplate,
    ModifVJsfInput,
    VuePhoneNumberInput,
    FormModalViewer,
    DynamicSelect,
    WarningDeleteMessage,
    SaveUserTemplate,
    SaveRole,
    SaveDependencies,
    ImgAvatar
  }
})
export default class SaveUser extends Vue {
  @Inject() userService!: UserService;
  @Inject() rolesService!: RolesService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() dependenciesService!: DependenciesService;
  @Inject() listService!: ListService;

  @Prop() userIdProp!: string;
  @Prop() updateDependencies!: boolean;
  @Prop({ default: false, required: false }) isModal!: boolean;
  @Prop() userDocumentProp?: string;
  @Prop({ default: false }) addPatientProp?: boolean;
  @Prop({ default: false }) disabledFieldsProp?: boolean;
  @Prop() nameUserProp?: string;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  options = VJSF_OPTIONS;
  countriesPreferredList = FORM_CONSTANTS.PREFERRED_COUNTRIES;
  translations = PHONE_TRANSLATIONS;

  userObject: UserModel = new UserModel();
  userObjectEditing: UserModel = new UserModel();
  userEmail = "";
  userPhone = "";
  name: string | string[] = ["", "", "", ""];
  pageTitle = USER_CONSTANTS.ADD_PAGE_TITLE;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  USER_NAME = USER_CONSTANTS.LABEL.USER_NAME;
  USER_PASSWORD = USER_CONSTANTS.LABEL.USER_PASSWORD;
  USER_PASSWORD_CONFIRM = USER_CONSTANTS.LABEL.USER_PASSWORD_CONFIRM;
  USER_NEW_PASSWORD = USER_CONSTANTS.LABEL.USER_NEW_PASSWORD;
  USER_NEW_PASSWORD_CONFIRM = USER_CONSTANTS.LABEL.USER_NEW_PASSWORD_CONFIRM;
  USER_ROL = USER_CONSTANTS.LABEL.USER_ROL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  PASSWORD_NOT_MATCH = USER_MESSAGES.EQUAL_PASSWORD;
  ADD_GROUP = USER_CONSTANTS.LABEL.ADD_GROUP;
  ADD_GROUP_TEXT = USER_CONSTANTS.LABEL.ADD_GROUP_TEXT;
  HINT_SEARCH_GROUP = USER_CONSTANTS.LABEL.HINT_SEARCH_GROUP;
  HINT_PROFILE_IMG = USER_CONSTANTS.LABEL.HINT_PROFILE_IMG;
  UPDATE_SCHEMA_GROUPS = USER_CONSTANTS.BUTTON.UPDATE_SCHEMA_GROUPS;
  HINT_TEMPLATE = USER_CONSTANTS.LABEL.HINT_TEMPLATE;
  SEARCH_TEMPLATE = USER_CONSTANTS.LABEL.SEARCH_TEMPLATE;
  ADD_TEMPLATE = USER_CONSTANTS.LABEL.ADD_TEMPLATE;
  USER_DEPENDENCY = USER_CONSTANTS.LABEL.USER_DEPENDENCY;
  USER_STATE = FORM_CONSTANTS.LABEL.STATE;
  PROFILE_IMG = USER_CONSTANTS.LABEL.PROFILE_IMG;
  USER_PHOTO_FORMAT = USER_PHOTO_FORMAT;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  MORE_GROUPS = USER_CONSTANTS.BUTTON.GROUP_BTN_TEXT;
  LOAD_MORE_OPTIONS = GENERAL_CONSTANTS.TEXTS.LOAD_MORE_OPTIONS;
  STATE = STATE;
  PANEL_INFO_CONSTANTS = PANEL_INFO_CONSTANTS;
  COMPONENT_NAME_MODAL = COMPONENT_NAME_MODAL;
  ADD_USER_TEMPLATE = USER_CONSTANTS.ADD_USER_TEMPLATE;
  ADD_ROLE = USER_CONSTANTS.ADD_ROLE_USER;
  ADD_DEPENDENCY = USER_CONSTANTS.ADD_DEPENDENCY;
  CREATE_INFORMATION_GROUP = USER_CONSTANTS.CREATE_INFORMATION_GROUP;
  NOT_FOUND_DATA = USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_DATA;

  userForm = false;
  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  priBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;

  showPassword = false;
  showPasswordConfirm = false;
  showGroup = false;
  dialogPreview = false;
  clearModel = false;
  searchGroups = true;
  modalDialogUser = false;
  modalTitleUser = "";
  modalTextUser = "";

  dependencyLastReference = "";
  filters: DependencyQuery = {};
  userPassword = "";
  userPasswordConfirm = "";
  userRoleList: RoleInfo[] = [];
  oldDocType = "";
  oldDepartment = "";
  oldCountry = "";
  document = "";
  listNameGroup: HeaderInfoGroup[] = [];
  infoGroupData: InfoGroupDetail = new InfoGroupDetail();
  schemaReady = true;
  vjsfKey = 0;
  phoneComplete = false;
  defaultCountry = "";
  isEditing = false;
  idEditing = "";
  existPasswordField = true;
  profileAvatar!: File;
  dependenciesList: Dependency[] = [];
  passwordErrorMsg: string[] = [];

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  ruleName = [FORM_VALIDATORS.REQUIRED_FIELD, USER_VALIDATORS.NO_SPACES];
  rulePassword = [
    USER_VALIDATORS.MIN_8,
    USER_VALIDATORS.NO_SPACES,
    USER_VALIDATORS.NO_SECUENCE,
    USER_VALIDATORS.CONTAINS_CAP_LETTER
  ];
  rulePasswordEdit = [USER_VALIDATORS.MIN_8, USER_VALIDATORS.NO_SPACES];

  ruleObjectRole = [this.selectAtLeastOne];
  dependencyObjectRole = [this.selectAtLeastOneDependency];
  ruleObjectTemp = [
    (v: HeaderUserTemplate) => !!v._key || FORM_MESSAGES.REQUIRED_FIELD
  ];
  WARNING_ITEMS_DELTED_INSIDE_TEMPLATE =
    GENERAL_CONSTANTS.TEXTS.WARNING_DELETED_ELEMENTS_INSIDE_TEMPLATE;
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;
  vCan = ["adminRole", "sameUser", this.userIdProp];

  dynamicSelectList: DynamicSelectData[] = [];
  templateSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SEARCH_TEMPLATE,
    hint: this.HINT_TEMPLATE,
    required: true,
    hideDetails: false,
    loadingData: true
  };

  roleSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.USER_ROL,
    notFound: false,
    showModalAdd: PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_ROLE,
    persistenthint: true,
    rules: this.ruleObjectRole,
    loadingData: true
  };

  dependencySelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: this.USER_DEPENDENCY,
    notFound: false,
    showModalAdd: PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_DEPENDENCIES,
    persistenthint: true,
    rules: this.dependencyObjectRole,
    loadingData: true,
    required: true
  };

  informationGroupsSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    hint: this.HINT_SEARCH_GROUP,
    persistenthint: true,
    messageLabel: this.ADD_GROUP,
    notFound: false,
    loadingData: true
  };

  lastRefRole = "";
  lastRefTemplate = "";
  lastRefGroups = "";
  notFound = false;

  addPatient = false;
  userDocument = "";
  userDocumentCopy = "";
  userDocumentKey = "";
  userPasswordAux = "";
  changePassword = false;
  validInfoGroupsFields = false;
  showModalUserTemplate = false;
  showModalRole = false;
  showModalDependencies = false;
  requiredUserMail = true;
  addRolItemMessage = USER_CONSTANTS.ADD_ROLE;
  addDependencyItemMessage = USER_CONSTANTS.ADD_DEPENDENCY;
  modalMessage = "";
  notFoundRoleItems = false;
  keyWordRole = "";
  keyWordDependency = "";
  notFoundDependencyItems = false;
  customErrorMessages: { [key: string]: string } = {};
  fieldIsUsed = false;

  userFormData: UserForm = {
    previewAvatar: USER_CONSTANTS.DEFAULT_IMG,
    model: {},
    schema: new GroupFullSchema(),
    phoneTypeList: [],
    phoneTypeTemplateList: [],
    user: "",
    state: true,
    extraInfoGroups: [],
    chosenTempId: "",
    rolesChosen: [],
    dependenciesChosen: [],
    groupsTemplateSelected: 0,
    templateState: "",
    groupsChosen: [],
    settedPassword: false
  };

  loadingData = false;
  loadingExtraCounter = 0;

  editComparationStr = "";
  invalidEdit = false;

  async beforeMount() {
    this.getUsersStates();
    this.addPatient = this.addPatientProp || false;
    await this.loadTemplates();
    await this.loadRoles();
    await this.loadDependencies("", this.addPatient);
  }

  async mounted() {
    const userId = this.$route.params.id
      ? this.$route.params.id
      : this.userIdProp;
    this.isEditing = userId ? true : false;
    this.userDocument = this.userDocumentProp || "";
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
    if (userId) {
      this.loadingData = true;
      this.idEditing = userId;
      await this.getDataUser(this.idEditing);
      await this.loadGroups();
    }
    this.$nextTick(function() {
      const passwordField = document.getElementById("userPasswordTxt");
      if (!passwordField) this.existPasswordField = false;
    });
    this.dependencySelectConfig.listAll = this
      .dependenciesList as DynamicSelectData[];
    this.roleSelectConfig.listAll = this.userRoleList;
    if (this.addPatient) await this.setDefaultUserData(this.userDocument);
    if (!this.isEditing) {
      this.rulePassword.push(FORM_VALIDATORS.REQUIRED_FIELD);
    }
    this.loadingData = false;
  }

  async handleGroupsId(ids: string[]) {
    const responseData = await this.infoGroupService.getInfoGroupByFilters({
      ids
    });

    let groupsSchema: FullSchema[] = [];
    groupsSchema = this.userFormData.schema.allOf.slice();
    groupsSchema.splice(this.userFormData.groupsTemplateSelected);

    if (responseData.code === Http.Found && responseData.data) {
      this.listNameGroup = [
        ...this.listNameGroup,
        ...responseData.data.groups.filter(
          g => groupsSchema.findIndex(e => e.idGroup === g._key) === -1
        )
      ];

      this.informationGroupsSelectConfig.listAll = this.listNameGroup.map(
        item => {
          return { ...item, id: item._key };
        }
      );
    }
  }

  @Watch("updateDependencies")
  async handleUpdateDependencies() {
    if (this.updateDependencies) {
      await this.loadDependencies();
    }
  }

  @Watch("userPassword")
  async validateUserPassword() {
    this.passwordErrorMsg = [];
    this.rulePassword.forEach(rule => {
      const result: string | boolean = rule(this.userPassword);
      if (typeof result == "string") {
        this.passwordErrorMsg.push(result);
      }
    });
  }

  @Watch("userFormData.model")
  async validateModel(newData: any) {
    const typeDocKey =
      this.getFieldKey(USER_CONSTANTS.FIELD.DOCUMENT_TYPE) ||
      FIELDS_MAPED_FROM_USER.IDENTIFICATION_TYPE;
    const newDocType = newData[typeDocKey];
    if (newData[BIRTHDAY_FIELD_MODEL.MODEL]) {
      this.validateBirthDate(
        newData[BIRTHDAY_FIELD_MODEL.MODEL],
        BIRTHDAY_FIELD_MODEL.INPUT_NAME
      );
    }
    if (
      newDocType != this.oldDocType &&
      this.userFormData.schema.allOf?.length > 0
    ) {
      this.oldDocType = newDocType;
      const docKey =
        this.getFieldKey(USER_CONSTANTS.FIELD.DOCUMENT) ||
        FIELDS_MAPED_FROM_USER.DOCUMENT;
      if (this.userFormData.schema.allOf[0].properties[docKey]) {
        this.userFormData.schema.allOf[0].properties[
          docKey
        ].pattern = NUMBER_PATTERN;
        const listOptionSchema = this.userFormData.schema.allOf[0].properties[
          typeDocKey
        ]?.oneOf?.find(e => e.const == newDocType);
        if (newDocType && listOptionSchema && listOptionSchema.alphanumeric) {
          this.userFormData.schema.allOf[0].properties[docKey].pattern = "";
        }
        this.vjsfKey++;
      }
    }
    if (this.oldDepartment != newData[FIELDS_MAPED_FROM_USER.DEPARTMENT]) {
      this.oldDepartment = newData[FIELDS_MAPED_FROM_USER.DEPARTMENT];
      await this.loadCities();
    }
    if (this.oldCountry != newData[FIELDS_MAPED_FROM_USER.COUNTRY]) {
      this.oldCountry = newData[FIELDS_MAPED_FROM_USER.COUNTRY];
      await this.loadDepartments();
    }
  }

  getFieldKey(name: string) {
    try {
      const properties = this.userFormData.schema.allOf[0].properties;
      const keys = Object.keys(properties);
      for (const key of keys) {
        if (properties[key].title.toUpperCase().includes(name.toUpperCase())) {
          return key;
        }
      }
      return "";
    } catch (error) {
      return "";
    }
  }

  @Watch("userIdProp")
  async changeFormTemplate() {
    this.loadingData = true;
    await this.loadTemplates();
    await this.loadRoles();
    if (this.userIdProp !== undefined && this.userIdProp !== "") {
      await this.getUserById(this.userIdProp);
      this.isEditing = true;
      this.pageTitle = USER_CONSTANTS.PAGE_EDIT_TITLE;
      await this.loadInactiveTemplate();
      await this.loadInactiveRoles();
      await this.loadInactiveDependencies();
    } else {
      this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
      this.isEditing = false;
      this.$nextTick(function() {
        const passwordField = document.getElementById("userPasswordTxt");
        if (!passwordField) this.existPasswordField = false;
      });
    }
    this.loadingData = false;
  }

  async getDataUser(idUser: string) {
    this.pageTitle = USER_CONSTANTS.PAGE_EDIT_TITLE;
    await this.getUserById(idUser);
    this.setReadonlySchema();
    this.loadInactiveTemplate();
    this.loadInactiveRoles();
    this.loadInactiveDependencies();
  }

  async handleModalAccept() {
    this.modalDialogUser = false;
    if (this.modalTitleUser == FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveUser();
    }
  }

  handleModalCancel() {
    this.modalDialogUser = false;
  }

  async saveUserModal(): Promise<void> {
    this.modalTitleUser = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalTextUser = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.modalDialogUser = true;
  }

  get chosenUserTemplate() {
    return this.dynamicSelectList[0];
  }

  async saveUser() {
    try {
      let responseData: Response<string | void>;
      const fields: FieldUserKey = this.getFieldsModel();
      let avatar = this.userObjectEditing.avatar || USER_CONSTANTS.DEFAULT_IMG;

      if (this.profileAvatar) avatar = await this.saveProfileAvatar();
      let isExternal = false;
      if (this.isEditing) {
        if (this.userPassword.length > 0 || this.userPasswordAux.length > 0) {
          this.userObjectEditing.password = this.userPassword
            ? this.userPassword
            : this.userPasswordAux;
        }

        this.userObjectEditing.user = this.userFormData.user;
        this.userObjectEditing.name = this.initCap(
          (
            this.name[0].trim() +
            " " +
            (this.name[1].includes("undefined") ? "" : this.name[1].trim())
          ).trim() +
            " " +
            (
              this.name[2].trim() +
              " " +
              (this.name[3].includes("undefined") ? "" : this.name[3].trim())
            ).trim()
        );
        this.userObjectEditing.avatar = avatar;
        this.userObjectEditing.document = this.document.trim();
        this.userObjectEditing.changedBy = localStorage.getItem("UID");
        this.userObjectEditing.roles = this.userFormData.rolesChosen.map(
          r => r.id
        );
        this.userObjectEditing.state = this.userFormData.state
          ? FORM_CONSTANTS.STATE.ACTIVE
          : FORM_CONSTANTS.STATE.INACTIVE;
        this.userObjectEditing.userTemplate = this.chosenUserTemplate.id;
        this.userObjectEditing.email = this.userEmail
          ? this.userEmail.trim().toLowerCase()
          : "";
        this.userObjectEditing.phone = this.userFormData.phoneTypeList[0].model.replace(
          /\s/g,
          ""
        );
        this.userObjectEditing.extraInfoGroups = this.userFormData.groupsChosen.map(
          group => group._key
        );
        this.userObjectEditing.fields = fields;
        delete this.userObjectEditing.schema;
        this.userObjectEditing.dependencies = this.userFormData.dependenciesChosen.map(
          dependency => dependency.id!
        );

        responseData = await this.userService.updateUser(
          this.idEditing,
          this.userObjectEditing
        );
      } else {
        isExternal = this.userFormData.dependenciesChosen.some(
          item => item.external == true
        );
        this.userObject = {
          avatar: avatar,
          user:
            this.userFormData.user != ""
              ? this.userFormData.user
              : this.document.trim(),
          email: this.userEmail ? this.userEmail.toLowerCase() : "",
          document: this.document.trim(),
          phone: this.userFormData.phoneTypeList[0].model.replace(/\s/g, ""),
          password: this.addPatient
            ? this.userPasswordAux || this.userFormData.user
            : "",
          roles: this.userFormData.rolesChosen.map(r => r.id),
          state: this.userFormData.state
            ? FORM_CONSTANTS.STATE.ACTIVE
            : FORM_CONSTANTS.STATE.INACTIVE,
          userTemplate: this.chosenUserTemplate.id,
          extraInfoGroups: this.userFormData.groupsChosen.map(
            group => group._key
          ),
          fields: fields,
          createdBy: localStorage.getItem("UID"),
          name: this.initCap(
            (this.name[0] + " " + this.name[1]).trim() +
              " " +
              (this.name[2] + " " + this.name[3]).trim()
          ),
          dependencies: this.userFormData.dependenciesChosen.map(
            dependency => dependency.id!
          )
        };

        responseData = await this.userService.addUser(this.userObject);
      }

      if (responseData.code == Http.Ok) {
        const responseUserId: string =
          responseData.data !== undefined ? responseData.data : "";

        Snackbar.popSuccess(responseData.message);
        if (responseUserId !== "" && isExternal && !this.isEditing) {
          this.$router.push(`${PROFILE_CONSTANTS.PATH}/${responseUserId}`);
        } else {
          this.onClose();
          if (responseUserId !== "") {
            this.$emit(USER_CONSTANTS.EVENT_DATA_USER_ID, responseUserId);
          }
        }
      } else if (responseData.code == Http.Created) {
        Snackbar.popWarning(responseData.message);
        this.onClose();
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof USER_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  initCap(value: string) {
    return value.toLowerCase().replace(/(?:^|\s)[a-z]/g, function(m) {
      return m.toUpperCase();
    });
  }

  getFieldsModel(): FieldUserKey {
    const fields: FieldUserKey = {};
    const schemaFields: FieldUserSchemaKey = {};
    const prop = this.userFormData.schema.allOf.map(g => g.properties);

    prop.forEach(e => Object.assign(schemaFields, e));
    for (const property in this.userFormData.model) {
      if (schemaFields[property]) {
        const fieldModel: FieldUser = {
          value:
            typeof this.userFormData.model[property] ==
            FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
              ? this.userFormData.model[property].trim()
              : this.userFormData.model[property],
          title:
            schemaFields[property].normalTitle || schemaFields[property].title
        };
        if (schemaFields[property].normalTitle === USER_CONSTANTS.FIELD.EMAIL) {
          this.userFormData.model[property] = this.userFormData.model[property]
            ? this.userFormData.model[property].trim().toLowerCase()
            : "";
          this.userEmail = this.userFormData.model[property].trim();
        } else if (
          schemaFields[property].normalTitle === USER_CONSTANTS.FIELD.PHONE
        ) {
          const phoneComponent = this.userFormData.phoneTypeTemplateList.find(
            phone => phone.title === USER_CONSTANTS.FIELD.PHONE
          );

          this.userPhone = phoneComponent
            ? `${phoneComponent.countryCallingCode}${phoneComponent.model}`
            : "";
        } else if (
          schemaFields[property].normalTitle === USER_CONSTANTS.FIELD.DOCUMENT
        ) {
          this.document = String(this.userFormData.model[property]).trim();
        } else if (
          schemaFields[property].normalTitle == USER_CONSTANTS.FIELD.FIRST_NAME
        ) {
          (this.name as string[])[0] = String(
            this.userFormData.model[property]
          ).trim();
        } else if (
          schemaFields[property].title == USER_CONSTANTS.FIELD.SECOND_NAME
        ) {
          (this.name as string[])[1] = String(
            this.userFormData.model[property]
          ).trim();
        } else if (
          schemaFields[property].normalTitle == USER_CONSTANTS.FIELD.SURNAME
        ) {
          (this.name as string[])[2] = String(
            this.userFormData.model[property]
          ).trim();
        } else if (
          schemaFields[property].title == USER_CONSTANTS.FIELD.SECOND_SURNAME
        ) {
          (this.name as string[])[3] = String(
            this.userFormData.model[property]
          ).trim();
        }

        switch (schemaFields[property].typeField) {
          case TYPE_FIELDS.LIST: {
            const titleOption: TitleList[] = [];
            let scoreSelectValue = null;
            const display = schemaFields[property]["x-display"];

            switch (display) {
              case FORMS_CONSTANTS.FIELD.RADIO:
              case FORMS_CONSTANTS.FIELD.SELECT: {
                const listOption = schemaFields[property].oneOf?.find(
                  item => item.const === this.userFormData.model[property]
                );

                titleOption.push({
                  type: display,
                  title: listOption?.title || "",
                  value: listOption?.const || ""
                });

                scoreSelectValue = listOption?.score;
                break;
              }
              case FORMS_CONSTANTS.FIELD.CHECKBOX: {
                for (const checkItem in this.userFormData.model[property]) {
                  const listOption = schemaFields[property].items?.oneOf?.find(
                    item =>
                      item.const ===
                      this.userFormData.model[property][checkItem]
                  );

                  titleOption.push({
                    title: listOption?.title || "",
                    value: listOption?.const || "",
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });
                }
                scoreSelectValue = null;
                break;
              }
              default: {
                throw Error;
              }
            }

            fieldModel.listTemplate = schemaFields[property].listTemplate;
            fieldModel.titleSelectValue = titleOption;
            fieldModel.scoreSelectValue = scoreSelectValue;
            break;
          }
          case TYPE_FIELDS.PHONE: {
            const indexPhone = this.userFormData.phoneTypeList.findIndex(
              p => p.slot === `custom-${property}`
            );

            const phoneModel: PhoneModel = {
              countryCode: this.userFormData.phoneTypeList[indexPhone].model
                ? this.userFormData.phoneTypeList[indexPhone].countryCode
                : "",
              countryCallingCode: this.userFormData.phoneTypeList[indexPhone]
                .model
                ? this.userFormData.phoneTypeList[indexPhone].countryCallingCode
                : "",
              model: this.userFormData.phoneTypeList[indexPhone].model
            };

            fieldModel.value = this.userFormData.phoneTypeList[
              indexPhone
            ].formattedNumber;
            fieldModel.phoneModel = phoneModel;
            break;
          }
        }
        fields[property] = fieldModel;
      }
    }
    return fields;
  }

  @Watch("dynamicSelectList")
  async updateSelectList() {
    await this.getTemplate(this.dynamicSelectList[0]?.id);
  }

  setInputsNameUser() {
    const schemaFields: FieldUserSchemaKey = {};
    const setSchema = this.userFormData.schema.allOf.map(g => g.properties);

    setSchema.forEach(e => Object.assign(schemaFields, e));
    const dataNames = this.processInputSearch();
    for (const property in schemaFields) {
      if (
        schemaFields[property].normalTitle == USER_CONSTANTS.FIELD.FIRST_NAME &&
        dataNames[0] !== undefined
      ) {
        this.userFormData.model[property] = dataNames[0];
      }
    }
  }

  processInputSearch() {
    const separateString = this.nameUserProp?.split(" ");
    const dataNames: string[] = [];
    const responseData: string[] = [];

    separateString?.forEach(element => {
      if (element !== "") {
        dataNames.push(element);
      }
    });

    const countedWords = dataNames.length;

    if (countedWords > 0) {
      let concatNames = "";
      let countString = 0;
      let stringD = "";
      dataNames.forEach(stringElement => {
        countString = countString + 1;
        stringD = dataNames[countString];

        if (stringElement.length > 3 && concatNames === "") {
          responseData.push(stringElement.trim());
        } else {
          if (stringD == undefined) {
            concatNames = concatNames + " " + stringElement;
            responseData.push(concatNames);
          } else {
            if (stringD.length >= 3 && concatNames !== "") {
              concatNames = concatNames + " " + stringElement;
            } else if (stringD.length < 3) {
              concatNames = concatNames + " " + stringElement;
            } else {
              responseData.push(stringElement.trim());
            }
          }
        }
      });
    }

    return responseData;
  }

  async loadRoles(roleName?: string) {
    try {
      if (roleName && roleName !== "") {
        await this.handleRole(roleName);
        return;
      }
      this.roleSelectConfig.loadingData = true;
      const querySearchRole: QuerySearchRole = {
        state: [STATE.ACTIVE],
        paginatedResult: true,
        docRef: this.lastRefRole
      };

      const responseData = await this.rolesService.getRolesByFiltersArrays(
        querySearchRole
      );

      this.roleSelectConfig.notFound = responseData.code === Http.NotFound;

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        if (this.lastRefRole) {
          this.userRoleList = [
            ...this.userRoleList,
            ...((responseData.data[
              NAME_KEY_CHART.LIST_ROLE
            ] as unknown) as RoleInfo[]).sort((role1, role2) =>
              role1.name.localeCompare(role2.name)
            )
          ];
        } else {
          this.userRoleList = ((responseData.data[
            NAME_KEY_CHART.LIST_ROLE
          ] as unknown) as RoleInfo[]).sort((role1, role2) =>
            role1.name.localeCompare(role2.name)
          );
        }

        this.lastRefRole = responseData.data.docRef
          ? responseData.data.docRef.toString()
          : "";
        this.roleSelectConfig.listAll = this.userRoleList;

        for (const element of this.userFormData.rolesChosen) {
          const exist = this.roleSelectConfig.listAll.find(
            (item: any) => item.name == element.name
          );
          if (!exist) {
            await this.handleRole(element.name);
          }
        }
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_ROLES);
      }
      this.roleSelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(`${errorMessage} - ${ERROR_CODES.SAVEUSER_GET_ROLES}`);
    }
  }

  async handleRole(name: string, creationRoleName?: boolean) {
    this.roleSelectConfig.loadingData = true;
    this.roleSelectConfig.notFound = false;
    const responseName = await this.rolesService.getRolesByFiltersArrays({
      name: [name.toUpperCase()],
      state: [STATE.ACTIVE]
    });
    if (responseName.code == Http.Found && responseName.data) {
      this.userRoleList = [
        ...this.userRoleList,
        ...((responseName.data[
          NAME_KEY_CHART.LIST_ROLE
        ] as unknown) as RoleInfo[]).sort((role1, role2) =>
          role1.name.localeCompare(role2.name)
        )
      ];
      this.roleSelectConfig.listAll = this.userRoleList;

      const newRoleCreated = this.userRoleList.find(role => role.name == name);

      if (newRoleCreated && creationRoleName)
        this.userFormData.rolesChosen.push(newRoleCreated);
    } else {
      this.roleSelectConfig.notFound = true;
    }
    this.roleSelectConfig.loadingData = false;
  }
  async handleUserTemplates(name: string) {
    this.templateSelectConfig.loadingData = true;
    this.templateSelectConfig.notFound = false;
    const responseData = await this.userTemplateService.getUserTempByFilters({
      name,
      state: QUERY_STATE_ACTIVE?.state
    });
    if (responseData.code === Http.Found && responseData.data) {
      this.templateSelectConfig.listAll = [
        ...this.templateSelectConfig.listAll,
        ...responseData.data.templates.map(item => {
          return {
            id: item._key,
            _key: item._key,
            name: item.name,
            state: item.state,
            description: item.description
          };
        })
      ];
    } else {
      this.templateSelectConfig.notFound = true;
    }
    this.templateSelectConfig.loadingData = false;
  }
  async loadTemplates(name?: string) {
    try {
      if (name) {
        await this.handleUserTemplates(name);
        return;
      }
      this.templateSelectConfig.loadingData = true;
      const query: UserTempQuerySend = {
        state: QUERY_STATE_ACTIVE?.state,
        paginatedResult: true,
        docref: this.lastRefTemplate
      };

      const responseData = await this.userTemplateService.getUserTempByFilters(
        query
      );

      this.templateSelectConfig.notFound = responseData.code === Http.NotFound;

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        if (this.lastRefTemplate) {
          this.templateSelectConfig.listAll = [
            ...this.templateSelectConfig.listAll,
            ...responseData.data.templates.map(item => {
              return {
                id: item._key,
                name: item.name,
                state: item.state,
                description: item.description
              };
            })
          ];
        } else {
          this.templateSelectConfig.listAll = responseData.data.templates.map(
            item => {
              return {
                id: item._key,
                name: item.name,
                state: item.state,
                description: item.description
              };
            }
          );
          for (const element of this.dynamicSelectList) {
            const exist = this.templateSelectConfig.listAll.find(
              item => item.name == element.name
            );
            if (!exist) {
              await this.handleUserTemplates(element.name);
            }
          }
        }
        this.lastRefTemplate = responseData.data.docref;
        this.templateSelectConfig.loadingData = true;

        if (!this.isEditing && !this.addPatientProp) {
          await this.selectDefaultValueTemplate();
        }
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_TEMPLATES);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(
        `${errorMessage} - ${ERROR_CODES.SAVEUSER_GET_TEMPLATES}`
      );
    }
  }

  async selectDefaultValueTemplate() {
    const defaultTemplate = this.templateSelectConfig.listAll.find(
      template => template.name == USER_CONSTANTS.SELECT_DEFAULT_TEMPLATE
    );

    if (defaultTemplate) {
      const template = await this.loadTemplatesById([defaultTemplate.id]);
      this.dynamicSelectList = [{ ...template[0], id: template[0]._key }];
      await this.getTemplate(this.dynamicSelectList[0]?.id);
    }
  }

  async loadTemplatesById(templId: string[]) {
    let listaTemp: HeaderUserTemplate[] = [];
    try {
      const data: UserTempQuerySend = {
        userTemplates: templId /*.filter(idSelect => !listId.includes(idSelect)) */
      };
      const responseData = await this.userTemplateService.getUserTempsByIdsArray(
        data
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        listaTemp = responseData.data as HeaderUserTemplate[];
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_TEMPLATES);
        listaTemp = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }

    return listaTemp;
  }

  async loadGroups() {
    if (!this.searchGroups) return;
    try {
      this.informationGroupsSelectConfig.loadingData = true;
      const responseData = await this.infoGroupService.getInfoGroupByFilters({
        state: FORM_CONSTANTS.STATE.ACTIVE,
        paginatedResult: true,
        docRef: this.lastRefGroups
      });
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        let groupsSchema: FullSchema[] = [];
        groupsSchema = this.userFormData.schema.allOf.slice();
        groupsSchema.splice(this.userFormData.groupsTemplateSelected);
        if (this.lastRefGroups) {
          this.listNameGroup = [
            ...this.listNameGroup,
            ...responseData.data.groups.filter(
              g => groupsSchema.findIndex(e => e.idGroup === g._key) === -1
            )
          ];
        } else {
          this.listNameGroup = responseData.data.groups.filter(
            g => groupsSchema.findIndex(e => e.idGroup === g._key) === -1
          );
        }

        this.informationGroupsSelectConfig.listAll = this.listNameGroup.map(
          item => {
            return {
              ...item,
              id: item._key
            };
          }
        );

        const idsSearch: string[] = [];
        for (const element of this.userFormData.extraInfoGroups) {
          const exist = this.informationGroupsSelectConfig.listAll.find(
            item => item._key == element
          );
          if (!exist) {
            idsSearch.push(element);
          }
        }
        if (idsSearch.length) await this.handleGroupsId(idsSearch);

        this.userFormData.groupsChosen = this.informationGroupsSelectConfig.listAll
          .filter(g => this.userFormData.extraInfoGroups.includes(g._key!))
          .slice() as any;

        this.lastRefGroups = responseData.data.docRef as string;
      } else {
        this.informationGroupsSelectConfig.notFound = true;
        this.listNameGroup = [];
      }
      this.informationGroupsSelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(`${errorMessage} - ${ERROR_CODES.SAVEUSER_GET_GROUPS}`);
    }
  }

  async showGroupsMenu() {
    this.showGroup = !this.showGroup;
  }

  async getTemplate(idRef: string) {
    this.schemaReady = false;
    try {
      const response = await this.userTemplateService.getUserTempSchemaById(
        idRef
      );
      this.vjsfKey++;

      if (response.code === Http.Found && response.data != null) {
        const phoneTypeListAux = lodash.cloneDeep(
          this.userFormData.phoneTypeList
        );
        const phoneTypeTemplateListAux = lodash.cloneDeep(
          this.userFormData.phoneTypeTemplateList
        );
        const newSchema = await this.setMandatoryFields(response.data.schema);
        const oldSchema = this.userFormData.schema.allOf;
        const docKey =
          this.getFieldKey(USER_CONSTANTS.FIELD.DOCUMENT) ||
          FIELDS_MAPED_FROM_USER.DOCUMENT;
        if (
          oldSchema &&
          oldSchema.length > 0 &&
          oldSchema[0].properties[docKey] &&
          newSchema.allOf.length > 0 &&
          newSchema.allOf[0].properties[docKey]
        ) {
          newSchema.allOf[0].properties[docKey] = {
            ...oldSchema[0].properties[docKey],
            ...newSchema.allOf[0].properties[docKey]
          };
        }
        this.userFormData.schema = newSchema;
        if (this.isEditing) {
          response.data.phoneComponentList.forEach(r => {
            if (
              this.userFormData.phoneTypeList.findIndex(
                p => r.slot === p.slot
              ) === -1
            ) {
              this.userFormData.phoneTypeList.push(r);
              this.userFormData.phoneTypeTemplateList.push(r);
            }
          });
        } else {
          this.userFormData.phoneTypeList = response.data.phoneComponentList;
          this.userFormData.phoneTypeTemplateList =
            response.data.phoneComponentList;
        }
        this.userFormData.groupsTemplateSelected = this.userFormData.schema.allOf.length;
        this.userFormData.phoneTypeList.forEach(phone => {
          phone.model =
            phoneTypeListAux.find(item => item.slot == phone.slot)?.model || "";
        });
        this.userFormData.phoneTypeTemplateList.forEach(phone => {
          phone.model =
            phoneTypeTemplateListAux.find(item => item.slot == phone.slot)
              ?.model || "";
        });
        if (this.userFormData.phoneTypeList.length > 0) {
          const indexInvalid = this.userFormData.phoneTypeList.findIndex(
            p =>
              (p.required && !p.isValid) ||
              (!p.required && p.model && !p.isValid)
          );

          if (indexInvalid !== -1) this.phoneComplete = false;
        }

        this.setInputsNameUser();
      } else if (response.code === Http.NotFound) {
        this.userFormData.phoneTypeList = [];
        this.userFormData.phoneTypeTemplateList = [];
        this.userFormData.groupsTemplateSelected = 0;
        Snackbar.popInfo(response.message);
      } else {
        this.userFormData.phoneTypeList = [];
        this.userFormData.phoneTypeTemplateList = [];
        this.userFormData.groupsTemplateSelected = 0;
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      this.userFormData.groupsTemplateSelected = 0;

      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
    this.searchGroups = true;
    this.showGroup = false;
    this.schemaReady = true;
  }

  async previewGroup(index: number) {
    try {
      const response = await this.infoGroupService.getInfoGroupSchemaById(
        this.userFormData.groupsChosen[index]._key
      );

      if (response.code === Http.Found && response.data != null) {
        this.infoGroupData = response.data;
        this.dialogPreview = true;
        this.clearModel = true;
      } else if (response.code === Http.NotFound) {
        Snackbar.popInfo(response.message);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }
  @Watch("userPassword")
  updatePassword() {
    if (this.isEditing) {
      this.invalidEdit = this.userPassword == "";
    }
  }
  @Watch("userFormData", { deep: true })
  checkEdit() {
    if (!this.loadingData && this.loadingExtraCounter >= 3) {
      this.invalidEdit =
        JSON.stringify(this.userFormData) === this.editComparationStr;
    } else if (!this.loadingData && this.loadingExtraCounter < 3) {
      this.loadingExtraCounter += 1;
      this.editComparationStr = JSON.stringify(this.userFormData);
    }
  }

  @Watch("userFormData.groupsChosen")
  async addNewGroups() {
    try {
      if (
        this.userFormData.schema.allOf.length >
        this.userFormData.groupsTemplateSelected
      ) {
        this.userFormData.schema.allOf.splice(
          this.userFormData.groupsTemplateSelected
        );
        this.userFormData.phoneTypeList = this.userFormData.phoneTypeTemplateList.slice();
      }
      const idsArray = this.userFormData.groupsChosen
        .map(group => group._key)
        .filter(
          id =>
            !this.userFormData.schema.allOf
              .map(schema => schema.idGroup)
              .includes(id)
        );
      if (idsArray.length == 0) {
        this.vjsfKey++;
        return;
      }

      const response = await this.userTemplateService.getUserTempSchemaByGroups(
        idsArray
      );

      if (response.code === Http.Found && response.data != null) {
        if (this.isEditing) {
          response.data.phoneComponentList.forEach(r => {
            if (
              this.userFormData.phoneTypeList.findIndex(
                p => r.slot === p.slot
              ) === -1
            ) {
              this.userFormData.phoneTypeList.push(r);
            }
          });
        } else {
          this.userFormData.phoneTypeList = this.userFormData.phoneTypeList.concat(
            response.data.phoneComponentList
          );
        }
        this.userFormData.schema.allOf = this.userFormData.schema.allOf.concat(
          response.data.schema.allOf
        );
      } else if (response.code === Http.NotFound) {
        Snackbar.popInfo(response.message);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
      this.vjsfKey++;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
    this.infoGroupData.phoneComponentList = [];
  }

  async getUserById(id: string) {
    try {
      const responseData = await this.userService.getUserById(id);
      if (responseData.code === Http.NotFound) {
        this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
        Snackbar.popError(
          USER_CONSTANTS.DIALOG_MESSAGE.ERROR_EDIT_ID_NOT_FOUND
        );
      } else if (
        responseData.code === Http.Found &&
        responseData.data !== undefined &&
        responseData.data.userData.schema !== undefined &&
        responseData.data.userData._key !== undefined
      ) {
        this.userFormData.previewAvatar =
          responseData.data.userData.avatar || "";
        this.userObjectEditing = responseData.data.userData;

        this.userFormData.model = responseData.data.userData.fields;
        this.userFormData.schema = await this.setMandatoryFields(
          responseData.data.userData.schema.schema
        );
        this.userFormData.phoneTypeList =
          responseData.data.userData.schema.phoneComponentList;
        this.userFormData.phoneTypeTemplateList =
          responseData.data.userData.schema.phoneComponentList;
        this.userFormData.user = responseData.data.userData.user;
        this.idEditing = responseData.data.userData._key;
        this.userFormData.state =
          responseData.data.userData.state === FORM_CONSTANTS.STATE.ACTIVE
            ? true
            : false;
        this.userFormData.extraInfoGroups =
          responseData.data.userData.extraInfoGroups;
        this.userFormData.chosenTempId =
          responseData.data.userData.userTemplate;
        this.userFormData.rolesChosen = responseData.data.userData
          .roles as RoleInfo[];
        this.userFormData.dependenciesChosen = responseData.data.userData
          .dependencies as Dependency[];
        this.userFormData.groupsTemplateSelected =
          responseData.data.userData.schema.schema.allOf.length -
          responseData.data.userData.extraInfoGroups.length;
        this.userFormData.templateState = responseData.data.userData.schema.state!;

        this.phoneComplete = true;

        const template = await this.loadTemplatesById([
          this.userFormData.chosenTempId
        ]);
        this.dynamicSelectList = [{ ...template[0], id: template[0]._key }];

        this.userFormData.groupsChosen = this.listNameGroup
          .filter(g => this.userFormData.extraInfoGroups.includes(g._key))
          .slice();

        this.userFormData.settedPassword =
          responseData.data.userData.settedPassword ?? false;

        for (const item of this.userFormData.groupsChosen) item.id = item._key;
      } else {
        this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  validateRequired(index: number): string {
    if (
      this.userFormData.phoneTypeList[index].required == true &&
      !this.userFormData.phoneTypeList[index].model
    ) {
      return "red";
    } else {
      return "#0B3352";
    }
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.userFormData.phoneTypeList[index].countryCode = payload.countryCode;
    this.userFormData.phoneTypeList[index].countryCallingCode =
      payload.countryCallingCode;
    this.userFormData.phoneTypeList[index].isValid = payload.isValid;
    this.userFormData.phoneTypeList[
      index
    ].formattedNumber = payload.formattedNumber ? payload.formattedNumber : "";
  }

  @Watch("userFormData.phoneTypeList", { deep: true })
  validateRequiredPhone() {
    const invalidPhones = this.userFormData.phoneTypeList.filter(
      p => (p.required && !p.isValid) || (!p.required && p.model && !p.isValid)
    );

    if (invalidPhones.length > 0) {
      this.phoneComplete = false;
    } else {
      this.phoneComplete = true;
    }
  }

  selectAtLeastOne() {
    return this.userFormData.rolesChosen.length > 0 || USER_MESSAGES.ONE_ROLE;
  }

  selectAtLeastOneDependency() {
    return (
      this.userFormData.dependenciesChosen.length > 0 ||
      USER_MESSAGES.ONE_DEPENDENCY
    );
  }

  getFileUploaded(file: File) {
    try {
      const validSize = USER_VALIDATORS.MAX_FILE_SIZE(file);
      const validFormat = USER_VALIDATORS.FILE_FORMAT(file);

      if (validSize === true && validFormat === true) {
        this.profileAvatar = file;
        this.userFormData.previewAvatar = URL.createObjectURL(file);
      } else {
        Snackbar.popError(
          (typeof validSize === "string" ? validSize : validFormat) + ""
        );
      }
    } catch (error) {
      this.userFormData.previewAvatar =
        this.userObjectEditing.avatar || USER_CONSTANTS.DEFAULT_IMG;
    }
  }

  async saveProfileAvatar() {
    try {
      const storageRef = firebase.storage().ref();
      const response = await storageRef
        .child(
          `${Utils.getClientStoragePath()}/avatars/${
            this.userFormData.user
          }-avatar.png`
        )
        .put(this.profileAvatar);

      if (response) return response.ref.getDownloadURL();
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }

    return USER_CONSTANTS.DEFAULT_IMG;
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  async setMandatoryFields(schema: GroupFullSchema): Promise<GroupFullSchema> {
    for (const allOffItem of schema.allOf) {
      if (allOffItem.required) {
        for (const propertyKey of allOffItem.required) {
          const title = allOffItem.properties[propertyKey].title;
          allOffItem.properties[propertyKey].title = `${title} *`;
          allOffItem.properties[propertyKey].normalTitle = title;
          if (title == USER_CONSTANTS.FIELD.DOCUMENT) {
            this.userDocumentCopy = this.userFormData.model[propertyKey];
            this.userDocumentKey = propertyKey;
            if (this.addPatient && this.userDocument) {
              this.userFormData.model[propertyKey] = this.userDocument;
            }
          }
        }
      }

      for (const property in allOffItem.properties) {
        if (property == FIELDS_MAPED_FROM_USER.CITY) {
          const listTemplateCity = allOffItem.properties[
            FIELDS_MAPED_FROM_USER.CITY
          ]
            ? allOffItem.properties[FIELDS_MAPED_FROM_USER.CITY].listTemplate
            : null;
          const departmentCode = this.userFormData.model[
            FIELDS_MAPED_FROM_USER.DEPARTMENT
          ];
          if (listTemplateCity && departmentCode) {
            const cities = await this.listService.getListCitiesByDepto(
              listTemplateCity,
              departmentCode
            );
            allOffItem.properties[
              FIELDS_MAPED_FROM_USER.CITY
            ].oneOf = cities.data?.optionsSchema.map(e => ({ ...e, score: 0 }));
          } else {
            allOffItem.properties[FIELDS_MAPED_FROM_USER.CITY].oneOf = [];
          }
        }
        if (property == FIELDS_MAPED_FROM_USER.DEPARTMENT) {
          const listTemplateDepto = allOffItem.properties[
            FIELDS_MAPED_FROM_USER.DEPARTMENT
          ]
            ? allOffItem.properties[FIELDS_MAPED_FROM_USER.DEPARTMENT]
                .listTemplate
            : null;
          const countryCode = this.userFormData.model[
            FIELDS_MAPED_FROM_USER.COUNTRY
          ];
          if (listTemplateDepto && countryCode) {
            const departments = await this.listService.getListDepartmentsByCountry(
              listTemplateDepto,
              countryCode
            );
            allOffItem.properties[
              FIELDS_MAPED_FROM_USER.DEPARTMENT
            ].oneOf = departments.data?.optionsSchema.map(e => {
              return {
                ...e,
                score: 0
              };
            });
          } else {
            allOffItem.properties[FIELDS_MAPED_FROM_USER.DEPARTMENT].oneOf = [];
          }
        }
      }
    }
    return schema;
  }

  onClose() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE);
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  hasInactiveInfoGroups() {
    return (
      (this.userFormData.schema.allOf || []).filter(
        schema => schema.state === STATE.INACTIVE
      ).length > 0
    );
  }

  hasInactiveRoles() {
    return (
      (this.userFormData.rolesChosen || []).filter(role => !role.state).length >
      0
    );
  }

  get templateChosen() {
    return this.dynamicSelectList.length == 0
      ? new HeaderUserTemplate()
      : ((this.dynamicSelectList[0] as unknown) as HeaderUserTemplate);
  }

  hasInactiveUserTemplate() {
    return this.templateChosen?.state == STATE.INACTIVE;
  }

  async loadDependencies(
    depName?: string,
    external?: boolean,
    updateRef = true
  ) {
    try {
      this.dependencySelectConfig.loadingData = true;
      if (depName) {
        await this.handleDependency(depName);
        return;
      }

      this.filters = {
        state: [STATE.ACTIVE],
        paginatedResult: true,
        docref: this.dependencyLastReference
      };

      if (this.dependencyLastReference !== "" && updateRef) {
        this.filters.docref = this.dependencyLastReference;
      } else {
        delete this.filters.docref;
      }
      if (external != undefined) this.filters.external = external;
      if (this.isAdmin && this.isEditing) {
        delete this.filters.external;
      }
      const response = await this.dependenciesService.getDependenciesWithFilters(
        this.filters
      );
      this.dependencyLastReference = response.data?.docRef ?? "";

      if (response.code === Http.Found && response.data) {
        if (this.dependencyLastReference !== "") {
          this.dependenciesList = [
            ...this.dependenciesList,
            ...response.data.data
          ];
        } else {
          this.dependenciesList = response.data.data.map(
            dependency => dependency
          );
        }
        this.dependencySelectConfig.listAll = this
          .dependenciesList as DynamicSelectData[];
        if (updateRef) this.dependencyLastReference = response.data.docRef;

        if (this.userFormData.dependenciesChosen[0]?.name) {
          const exist = this.dependencySelectConfig.listAll.find(
            item =>
              item.name.trim() ==
              this.userFormData.dependenciesChosen[0].name.trim()
          );
          if (!exist) {
            await this.handleDependency(
              this.userFormData.dependenciesChosen[0].name.trim()
            );
          }
        }
      } else {
        this.dependencySelectConfig.notFound = true;
        this.dependencyLastReference = "";
        Snackbar.popInfo(response.message);
      }
      this.dependencySelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DEPENDENCIES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.filters.docref = "";
      Snackbar.popError(
        `${errorMessage} - ${ERROR_CODES.SAVEUSER_GET_DEPENDENCIES}`
      );

      return;
    }
  }

  async handleDependency(depName: string, createNameDep?: boolean) {
    this.dependencySelectConfig.loadingData = true;
    this.dependencySelectConfig.notFound = false;
    const responseName = await this.dependenciesService.getDependenciesWithFilters(
      { name: depName.toUpperCase(), state: [STATE.ACTIVE] }
    );
    if (responseName.code == Http.Found && responseName.data) {
      this.dependenciesList = [
        ...this.dependenciesList,
        ...responseName.data.data
      ];
      this.dependencySelectConfig.listAll = this
        .dependenciesList as DynamicSelectData[];

      if (createNameDep && responseName.data && responseName.data.data[0]) {
        const dependecyAdded = responseName.data.data[0];
        const index = this.dependenciesList.findIndex(
          dep => dep.id == dependecyAdded.id
        );
        index != -1
          ? (this.dependenciesList[index] = dependecyAdded)
          : this.dependenciesList.push(
              responseName.data.data.map(dependency => dependency)[0]
            );
        this.userFormData.dependenciesChosen.push(
          responseName.data.data.map(dependency => dependency)[0]
        );
      }
    } else {
      this.dependencySelectConfig.notFound = true;
    }
    this.dependencySelectConfig.loadingData = false;
  }

  async getDefaultRol() {
    const defaultRol = this.userRoleList.find(
      role => role.name == USER_CONSTANTS.DEFAULT_ROLE
    )!;
    if (!defaultRol) {
      await this.handleRole(USER_CONSTANTS.DEFAULT_ROLE);
      return this.userRoleList.find(
        role => role.name == USER_CONSTANTS.DEFAULT_ROLE
      )!;
    }
    return defaultRol;
  }

  async getDefaultTemplate() {
    const defaultTemplate = this.templateSelectConfig.listAll.find(
      template => template.name == USER_CONSTANTS.DEFAULT_TEMPLATE
    );
    if (!defaultTemplate) {
      await this.handleUserTemplates(USER_CONSTANTS.DEFAULT_TEMPLATE);
      return this.templateSelectConfig.listAll.find(
        template => template.name == USER_CONSTANTS.DEFAULT_TEMPLATE
      )!;
    }
    return defaultTemplate;
  }

  async getDefaultDependency(defaultDependencies: Dependency[]) {
    const defaultDependency = defaultDependencies.find(
      dependency =>
        dependency.name.toLowerCase() ==
        USER_CONSTANTS.DEFAULT_DEPENDENCY.toLowerCase()
    );
    if (!defaultDependency) {
      await this.handleDependency(USER_CONSTANTS.DEFAULT_DEPENDENCY);
      return defaultDependencies.find(
        dependency =>
          dependency.name.toLowerCase() ==
          USER_CONSTANTS.DEFAULT_DEPENDENCY.toLowerCase()
      );
    }
    return defaultDependency;
  }

  async setDefaultUserData(document: string) {
    const defaultRole = await this.getDefaultRol();
    const defaultTemplate = await this.getDefaultTemplate();
    const defaultDependencies = this.dependenciesList.filter(
      dependency => dependency.external
    );
    const defaultDependency = await this.getDefaultDependency(
      defaultDependencies
    );
    if (
      defaultDependency &&
      !this.userFormData.dependenciesChosen.find(
        dependency => dependency.name == defaultDependency.name
      )
    ) {
      this.userFormData.dependenciesChosen.push(defaultDependency);
    } else {
      this.filters.name = USER_CONSTANTS.DEFAULT_DEPENDENCY;
      await this.loadDependencies("", true, false);
      delete this.filters.name;
      const defaultDependency = this.dependenciesList.find(
        dependency =>
          dependency.name.toLowerCase() ==
          USER_CONSTANTS.DEFAULT_DEPENDENCY.toLowerCase()
      );
      if (
        defaultDependency &&
        !this.userFormData.dependenciesChosen.find(
          dependency => dependency.name == defaultDependency.name
        )
      )
        this.userFormData.dependenciesChosen.push(defaultDependency);
    }

    if (!this.isEditing) {
      this.userPassword = document;
      this.userPasswordConfirm = document;
      this.userFormData.user = document;

      if (defaultTemplate) {
        const template = await this.loadTemplatesById([defaultTemplate.id]);
        this.dynamicSelectList = [{ ...template[0], id: template[0]._key }];
      }
      await this.getTemplate(this.dynamicSelectList[0]?.id);

      this.userFormData.rolesChosen = [defaultRole];

      if (this.dependenciesList.length == 1)
        this.userFormData.dependenciesChosen = defaultDependencies;
      return;
    }

    if (
      !this.userFormData.rolesChosen.find(
        role =>
          role.name.toLowerCase() == USER_CONSTANTS.DEFAULT_ROLE.toLowerCase()
      )
    )
      this.userFormData.rolesChosen.push(defaultRole);

    if (
      this.dependenciesList.length == 1 &&
      !this.userFormData.dependenciesChosen.find(
        dependency => dependency.name == defaultDependencies[0].name
      )
    )
      this.userFormData.dependenciesChosen.push(defaultDependencies[0]);
  }

  get isAdmin(): boolean {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS) ?? "[]";
    return views.includes(LOCAL_STORAGE.ADMIN_ROLE);
  }

  async loadInactiveTemplate() {
    try {
      if (this.userFormData.templateState === STATE.INACTIVE) {
        const data: UserTempQuerySend = {
          userTemplates: [this.userFormData.chosenTempId]
        };
        const response = await this.userTemplateService.getUserTempsByIdsArray(
          data
        );
        if (response.code === Http.Found && response.data !== undefined) {
          this.templateSelectConfig.listAll = this.templateSelectConfig.listAll.concat(
            ({
              id: response.data[0]._key!,
              name: response.data[0].name!,
              description: response.data[0].description!,
              state: response.data[0].state!
            } as unknown) as DynamicSelectData
          );
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadInactiveRoles() {
    try {
      const thereAreInactiveRoles: string[] = this.userFormData.rolesChosen
        .filter(role => role.state === false)
        .map(role => role.id);

      if (thereAreInactiveRoles.length > 0) {
        const response = await this.rolesService.getRolesByFiltersArrays({
          idRole: thereAreInactiveRoles,
          chart: "false"
        });

        if (response.code === Http.Found && response.data !== undefined) {
          this.userRoleList = this.userRoleList.concat(
            (response.data[NAME_KEY_CHART.LIST_ROLE] as unknown) as RoleInfo[]
          );
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadInactiveDependencies() {
    try {
      const thereAreInactiveDependencies = this.userFormData.dependenciesChosen
        .filter(dependency => dependency.state === STATE.INACTIVE)
        .map(dependency => dependency.id);

      if (thereAreInactiveDependencies.length > 0) {
        const response = await this.dependenciesService.getDependenciesWithFilters(
          {
            id: thereAreInactiveDependencies as string[]
          }
        );

        if (response.code === Http.Found && response.data !== undefined) {
          this.dependenciesList = this.dependenciesList.concat(
            response.data.data
          );
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DEPENDENCIES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      this.filters.docref = "";
      Snackbar.popError(errorMessage);
    }
  }

  @Watch("disabledFieldsProp")
  setReadonlySchema() {
    if (this.userFormData.schema && this.userFormData.schema.allOf) {
      this.userFormData.schema.allOf.forEach(field => {
        Object.keys(field.properties).forEach(key => {
          if (
            field.properties[key]["x-display"] ==
            FORM_TEMP_CONSTANTS.FIELD_TYPE.SLIDER
          )
            field.properties[key].readOnly = this.disabledFieldsProp;
          field.properties[key]["x-options"] = {
            ...field.properties[key]["x-options"],
            disableAll: this.disabledFieldsProp
          };
        });
      });
    }
    this.userFormData.phoneTypeList.forEach(phone => {
      phone.enabled = !this.disabledFieldsProp;
    });
    this.changePassword = !this.disabledFieldsProp;
  }

  onBlur(key: string) {
    if (
      this.userDocumentCopy != this.userFormData.model[key] &&
      this.userDocumentKey == key
    ) {
      this.userFormData.user = this.userFormData.model[key];
      this.userPasswordAux = this.userFormData.model[key];
      this.userDocumentCopy = this.userFormData.model[key];
    }
    if (this.userFormData.schema.allOf) {
      this.userFormData.schema.allOf.forEach(item => {
        if (item.properties[key].type == FORM_TEMP_CONSTANTS.FIELD_TYPE.EMAIL) {
          this.validateUniqueEmail({
            key: key,
            value: this.userFormData.model[key]
          });
        }
      });
    }
  }

  onRequiredComplete(valid: boolean) {
    this.validInfoGroupsFields = valid;
  }

  addElement(modal?: string) {
    switch (modal) {
      case PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_ROLE:
        Utils.changeStateList(this, USER_CONSTANTS.ROLE_SELECT, false);
        this.showModalRole = true;
        break;
      case PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_DEPENDENCIES:
        Utils.changeStateList(this, USER_CONSTANTS.DEPENDENCIES_SELECT, false);
        this.showModalDependencies = true;
        break;
      default:
        this.showModalUserTemplate = true;
        break;
    }
  }

  closeOptionsModal(modal: string) {
    this.modalMessage = modal;
    if (modal !== this.COMPONENT_NAME_MODAL.DEPENDENCY) {
      const modalUserTemplate: SearchContextModal = {
        componentName: modal,
        callbackHandleOperation: this.handleOperation
      };
      Utils.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
        modalUserTemplate
      );
    } else {
      this.onCloseDependencyModal();
    }
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      switch (this.modalMessage) {
        case COMPONENT_NAME_MODAL.DEPENDENCY:
          this.onCloseDependencyModal();
          break;
        case COMPONENT_NAME_MODAL.ROLE:
          this.onCloseRoleModal();
          break;
        case COMPONENT_NAME_MODAL.USER_TEMPLATE:
          this.onCloseUserTemplateModal();
          break;
      }
    }
  }
  onCloseUserTemplateModal(templateName?: string) {
    this.modalMessage = "";
    this.showModalUserTemplate = false;
    this.loadTemplates(templateName);
  }
  async onCloseRoleModal(rolName?: string, createNameRole?: boolean) {
    this.modalMessage = "";
    this.showModalRole = false;
    if (rolName) await this.handleRole(rolName, createNameRole);
  }
  async onCloseDependencyModal(depName?: string, createNameDep?: boolean) {
    this.modalMessage = "";
    this.showModalDependencies = false;
    this.dependencyLastReference = "";
    if (depName) await this.handleDependency(depName, createNameDep);
  }

  @Watch("keyWordRole")
  searchItemRole() {
    Utils.searchItem(
      this.userRoleList,
      this.keyWordRole,
      NAME_FIELD,
      this.setNotFoundRoleItems
    );
  }

  @Watch("keyWordDependency")
  searchItemDependency() {
    Utils.searchItem(
      this.dependenciesList,
      this.keyWordDependency,
      NAME_FIELD,
      this.setNotFoundDependencyItems
    );
  }

  setNotFoundRoleItems(state: boolean) {
    this.notFoundRoleItems = state;
  }

  setNotFoundDependencyItems(state: boolean) {
    this.notFoundDependencyItems = state;
  }

  async validateUniqueEmail(field: { key: string; value: string }) {
    this.fieldIsUsed = false;
    if (field.value.trim() == "") {
      return;
    }
    this.customErrorMessages = {};
    const query = { userEmail: field.value, userId: this.userIdProp };
    const rta = await this.userService.checkIfExistByEmail(query);
    this.vjsfKey++;
    if (rta.code == Http.Found) {
      this.fieldIsUsed = true;
      this.customErrorMessages[field.key] =
        GENERAL_CONSTANTS.MESSAGE_EMAIL_USED;
    }
  }

  @Watch("userFormData.dependenciesChosen")
  handleDependenciesChosen() {
    const requiredUserMail =
      this.userFormData.dependenciesChosen &&
      this.userFormData.dependenciesChosen.length > 0
        ? this.userFormData.dependenciesChosen.some(
            item => item.external === false
          )
        : true;
    const emailField = this.getMailField();
    if (emailField) {
      const index = this.userFormData.schema.allOf[0].required?.indexOf(
        emailField
      );
      const title = this.userFormData.schema.allOf[0].properties[emailField]
        .normalTitle;
      if (!requiredUserMail && emailField != "") {
        if (index) {
          this.userFormData.schema.allOf[0].required?.splice(index, 1);
          this.userFormData.schema.allOf[0].properties[
            emailField
          ].title = `${title}`;
        }
      } else if (requiredUserMail && emailField != "") {
        if (index && index == -1) {
          this.userFormData.schema.allOf[0].required?.push(emailField);
          this.userFormData.schema.allOf[0].properties[
            emailField
          ].title = `${title} *`;
        }
      }
    }
  }

  getMailField(): string {
    let emailField = "";
    try {
      this.userFormData.schema.allOf.forEach(allOffItem => {
        Object.keys(allOffItem.properties).some(propertyKey => {
          if (
            allOffItem.properties[propertyKey].normalTitle ===
            USER_CONSTANTS.FIELD.EMAIL
          ) {
            emailField = propertyKey;
            return true;
          }
        });
      });
    } catch (error) {
      emailField = "";
    }
    return emailField;
  }
  validateBirthDate(valueModel: string, keyField: string) {
    const selectDate = new Date(valueModel);
    const currentDate = new Date();
    const formatActualDate = currentDate
      .toISOString()
      .split(BIRTHDAY_FIELD_MODEL.SEPARATOR)[0];
    const formatSelectedDate = selectDate
      .toISOString()
      .split(BIRTHDAY_FIELD_MODEL.SEPARATOR)[0];
    if (formatSelectedDate > formatActualDate) {
      Snackbar.popWarning(USER_CONSTANTS.DIALOG_MESSAGE.DATE_BIRTH_GREATER);
      const inputElement = document.getElementById(
        keyField
      ) as HTMLInputElement;
      inputElement.focus();
      inputElement.value = BIRTHDAY_FIELD_MODEL.CLEAR_VALUE;
      inputElement.dispatchEvent(new Event(BIRTHDAY_FIELD_MODEL.INPUT_LABEL));
    }
  }

  async loadCities() {
    if (
      !this.userFormData.schema.allOf ||
      (this.userFormData.schema.allOf &&
        this.userFormData.schema.allOf.length == 0)
    ) {
      return;
    }
    const listTemplate = this.userFormData.schema.allOf[0].properties[
      FIELDS_MAPED_FROM_USER.CITY
    ]
      ? this.userFormData.schema.allOf[0].properties[
          FIELDS_MAPED_FROM_USER.CITY
        ].listTemplate
      : null;
    const departmentCode = this.userFormData.model[
      FIELDS_MAPED_FROM_USER.DEPARTMENT
    ];
    if (listTemplate) {
      const cities = await this.listService.getListCitiesByDepto(
        listTemplate,
        departmentCode
      );
      this.userFormData.schema.allOf[0].properties[
        FIELDS_MAPED_FROM_USER.CITY
      ].oneOf = cities.data?.optionsSchema.map(e => {
        return {
          ...e,
          score: 0
        };
      });
      this.vjsfKey++;
    }
  }

  async loadDepartments() {
    if (
      !this.userFormData.schema.allOf ||
      (this.userFormData.schema.allOf &&
        this.userFormData.schema.allOf.length == 0)
    ) {
      return;
    }
    const listTemplate = this.userFormData.schema.allOf[0].properties[
      FIELDS_MAPED_FROM_USER.DEPARTMENT
    ]
      ? this.userFormData.schema.allOf[0].properties[
          FIELDS_MAPED_FROM_USER.DEPARTMENT
        ].listTemplate
      : null;
    const countryCode = this.userFormData.model[FIELDS_MAPED_FROM_USER.COUNTRY];
    if (listTemplate) {
      const departments = await this.listService.getListDepartmentsByCountry(
        listTemplate,
        countryCode
      );
      this.userFormData.schema.allOf[0].properties[
        FIELDS_MAPED_FROM_USER.DEPARTMENT
      ].oneOf = departments.data?.optionsSchema.map(e => {
        return {
          ...e,
          score: 0
        };
      });
      this.vjsfKey++;
    }
  }

  async getUsersStates() {
    try {
      const usersStatesResponse = await this.listService.getListOptionsByName(
        LIST_CONSTANTS.USERS_STATES_LIST_NAME
      );
      if (
        usersStatesResponse.code === Http.Found &&
        usersStatesResponse.data !== undefined
      ) {
        this.USER_STATE = usersStatesResponse.data.find(
          state => state.id == USER_STATES.ACTIVE
        )?.title as string;
        return;
      }
      Snackbar.popInfo(usersStatesResponse.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
